/// <amd-module name="Test/Analytics/TestAnalyticsTrendChart/Actions/TestInsightsTrendChartActions" />
import * as CommonTypes from "Test/Analytics/Common/Types";
import { ITrendChartData } from "Test/Analytics/TrendChartCommon/Types";
import { Action } from "VSS/Reflux/Action";

export class TestInsightsTrendChartActions {
    public updateConfigurationValuesAction: Action<CommonTypes.IReportConfiguration> = new Action<CommonTypes.IReportConfiguration>();
    public updateTrendChartAction: Action<ITrendChartData> = new Action<ITrendChartData>();
    public onError = new Action<Error>();
}
